import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services';
import { IVendorOnboardingApprovalView } from '../models/venodor-onboarding-approval-view.model';

@Injectable({
  providedIn: 'root'
})
export class VendorOnboardApprovalViewService {
  constructor(private http: HttpClient,
    private apiService: ApiService) { }
  public OnboardProcessDetailsMSPView(vendorId: number, userProfileId: number): Observable<any> {
    return this.apiService.get(`VendorOnboardProcess/OnboardProcessDetailsMSPView/${vendorId}/${userProfileId}`)
  }

  public ApproveVendorOnboardProcessDetailsByMSP(value: IVendorOnboardingApprovalView): Observable<any> {
    console.log(value);
    return this.apiService.post(`VendorOnboardProcess/ApproveVendorOnboardProcessDetailsByMSP`, value)
  }

  public reApproveRejectedDocument(value: any): Observable<any> {
    return this.apiService.post(`VendorOnboardProcess/ApproveVendorOnBoardingDocument`, value)
  }
}